import { takeLatest, call, put, select } from 'redux-saga/effects';

// Services
import { cardReceivablesApi } from 'services/apiDigitalTicket/cardReceivables';

// Actions
import * as CardReceivablesActions from './actions';

import { CardReceivablesTypes } from './types';

function* getPendencies({
  payload,
  meta,
}: ReturnType<
  typeof CardReceivablesActions.getCardPendenciesRequest
>): any {
  try {
    const { cardNumber, expirationDate } = payload;
    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );
    const response = yield call(cardReceivablesApi.getPendencies, {
      cardNumber,
      expirationDate,
      transportOperatorId: transportOperator.id,
    });

    if (response.status === 200) {
      yield put(
        CardReceivablesActions.getCardPendenciesSuccess({
          cardNumber,
          transactionsList: response.data,
        }),
      );
      meta.promise.resolve(response.data);
    } else {
      throw response;
    }
  } catch (error) {
    yield put(CardReceivablesActions.getCardPendenciesFailure());
    meta.promise.reject(error);
  }
}

function* generatePayment({
  payload,
  meta,
}: ReturnType<
  typeof CardReceivablesActions.generateCardPaymentRequest
>): any {
  try {
    const { cardNumber, transactionIds } = payload;
    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );
    const response = yield call(cardReceivablesApi.generatePayment, {
      cardNumber,
      transactionIds,
      transportOperatorId: transportOperator.id,
      transportOperatorName: transportOperator.name,
    });

    if (response.status === 200) {
      yield put(
        CardReceivablesActions.generateCardPaymentSuccess({
          pixPayment: response.data,
        }),
      );
      meta.promise.resolve(response.data);
    } else {
      throw response;
    }
  } catch (error) {
    yield put(CardReceivablesActions.generateCardPaymentFailure());
    meta.promise.reject(error);
  }
}

function* getHistory({
  payload,
  meta,
}: ReturnType<typeof CardReceivablesActions.getCardHistoryRequest>): any {
  try {
    const { cardNumber, expirationDate } = payload;
    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );
    const response = yield call(cardReceivablesApi.getHistory, {
      cardNumber,
      expirationDate,
      transportOperatorId: transportOperator.id,
    });

    if (response.status === 200) {
      yield put(
        CardReceivablesActions.getCardHistorySuccess({
          historyList: response.data,
        }),
      );
      meta.promise.resolve(response.data);
    } else {
      throw response;
    }
  } catch (error) {
    yield put(CardReceivablesActions.getCardHistoryFailure());
    meta.promise.reject(error);
  }
}

function* refreshPayment({
  payload,
  meta,
}: ReturnType<typeof CardReceivablesActions.refreshCardPaymentRequest>): any {
  try {
    const { paymentId } = payload;
    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );
    const response = yield call(cardReceivablesApi.refreshPayment, {
      paymentId,
      transportOperatorId: transportOperator.id,
    });

    if (response.status === 200) {
      yield put(
        CardReceivablesActions.refreshCardPaymentSuccess({
          payment: response.data,
        }),
      );
      meta.promise.resolve(response.data);
    } else {
      throw response;
    }
  } catch (error) {
    yield put(CardReceivablesActions.refreshCardPaymentFailure());
    meta.promise.reject(error);
  }
}

function* releasePayment({
  payload,
  meta,
}: ReturnType<typeof CardReceivablesActions.releaseCardPaymentRequest>): any {
  try {
    const { paymentId } = payload;
    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );
    const response = yield call(cardReceivablesApi.releasePayment, {
      paymentId,
      transportOperatorId: transportOperator.id,
    });

    if (response.status === 200) {
      yield put(
        CardReceivablesActions.releaseCardPaymentSuccess({
          payment: response.data,
        }),
      );
      meta.promise.resolve(response.data);
    } else {
      throw response;
    }
  } catch (error) {
    yield put(CardReceivablesActions.releaseCardPaymentFailure());
    meta.promise.reject(error);
  }
}

// eslint-disable-next-line import/prefer-default-export
export const cardReceivablesSagas = [
  takeLatest(CardReceivablesTypes.GET_CARD_PENDENCIES_REQUEST, getPendencies),
  takeLatest(
    CardReceivablesTypes.GENERATE_CARD_PAYMENT_REQUEST,
    generatePayment,
  ),
  takeLatest(CardReceivablesTypes.GET_CARD_HISTORY_REQUEST, getHistory),
  takeLatest(CardReceivablesTypes.REFRESH_CARD_PAYMENT_REQUEST, refreshPayment),
  takeLatest(CardReceivablesTypes.RELEASE_CARD_PAYMENT_REQUEST, releasePayment),
];
